import PropTypes from 'prop-types';

import { colors } from 'styles/theme';

/**
 * @param {object} props
 */
function BrandLogoIcon({ color = colors.darkPurple, className = '' }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="33"
      height="27"
      viewBox="0 0 33 27"
      className={className}
    >
      <g fill="none" fillRule="evenodd" stroke={color} strokeWidth="1.515">
        <path d="M9.418 23.428a7.146 7.146 0 0 1 0-10.105l5.05-5.05-1.225-1.224A7.146 7.146 0 0 0 3.138 17.154l6.274 6.274a7.123 7.123 0 0 0 5.056 2.093 7.124 7.124 0 0 1-5.05-2.093zM29.71 3.137a7.146 7.146 0 0 0-10.106 0l-5.136 5.136 5.05 5.05a7.146 7.146 0 0 1-5.05 12.198c1.83.001 3.66-.696 5.056-2.093l10.185-10.185a7.146 7.146 0 0 0 0-10.106z" />
        <path d="M19.517 23.428a7.146 7.146 0 0 0 0-10.105l-5.05-5.05-5.049 5.05a7.146 7.146 0 0 0 5.05 12.198 7.123 7.123 0 0 0 5.05-2.093z" />
      </g>
    </svg>
  );
}

BrandLogoIcon.propTypes = {
  className: PropTypes.string,
  color: PropTypes.string,
};

export default BrandLogoIcon;
